import Core from '../core';
import { AxiosError, AxiosResponse } from 'axios';

async function getWeekoffNTimeshift(employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmployeeAttendanceDetails?empId=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getEmpTimeSheetList(company_id: number, employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getTimeSheet?companyId=${company_id}&empId=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getTimesheet(
  company_id: number,
  employee_id: number,
  year: number,
  month: number,
  from_date?: any,
  to_date?: any,
  pageSize?: number,
  page?: number,
  isAdminView?: any,
  adminId?: any
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/emp/attendances?companyId=${company_id}&empId=${employee_id}&year=${year}&month=${month}&from_date=${from_date}&to_date=${to_date}&rowsPerPage=${pageSize}&page=${page}&isAdminView=${isAdminView}&userId=${adminId}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
export const attendanceServices = {
  getWeekoffNTimeshift,
  getTimesheet,
  getEmpTimeSheetList,
};
